import React, { Fragment, FunctionComponent } from "react";
import { connect, MapStateToProps } from "react-redux";

import { Divider } from "@multiweb/reactComponents";
import { IAppState } from "@multiweb/types/react";
import { getActivityByIndex, isStatusViewEnabled } from "../../selectors";
import { IActivity, WorkflowEditorProps } from "../../types";
import { ActionsContainer, ActiveParticipantsContainer, ActivityPropertiesContainer, ParticipantsContainer, PertienceToSetsContainer, TriggersContainer } from "./containers";

type ActivityPropertyPanelComponentProps = {
    readonly activity: IActivity;
    readonly picassoComponentId: number;
    readonly isStatusViewEnabled: boolean;
} & WorkflowEditorProps;

const ActivityPropertyPanelComponent: FunctionComponent<ActivityPropertyPanelComponentProps> = ({ activity, isStatusViewEnabled, hostKey }) => {
    const { id: activityId, picassoIndex, actions, triggers, participants, activeParticipants, positions } = activity;

    return (
        <Fragment>
            <ActivityPropertiesContainer {...{ picassoIndex, hostKey, activity }} />
            <Divider />
            <ActionsContainer {...{ picassoIndex, hostKey, actions }} />
            <Divider />
            <TriggersContainer {...{ picassoIndex, hostKey, triggers }} />
            <Divider />
            <ParticipantsContainer {...{ picassoIndex, hostKey, participants }} />
            <Divider />
            {isStatusViewEnabled && <Fragment>
                <ActiveParticipantsContainer {...{ hostKey, activeParticipants }} />
                <Divider />
            </Fragment>}
            <PertienceToSetsContainer {...{ hostKey, positions, activityId }} />
            <Divider />
        </Fragment>
    );
};

type StateProps = Pick<ActivityPropertyPanelComponentProps, "activity" | "isStatusViewEnabled">;
type ActivityPropertyPanelProps = Pick<ActivityPropertyPanelComponentProps, "hostKey" | "picassoComponentId">;

const mapStateToProps: MapStateToProps<StateProps, ActivityPropertyPanelProps, IAppState> = (state, { hostKey, picassoComponentId }) => ({
    activity: getActivityByIndex(state, hostKey, picassoComponentId),
    isStatusViewEnabled: isStatusViewEnabled(state, hostKey),
});

export const ActivityPropertyPanel = connect(mapStateToProps)(ActivityPropertyPanelComponent);
